// ** React Imports
import { Link } from "react-router-dom"

// ** Reactstrap Imports
import { Button } from "reactstrap"

// ** Styles
import "../../@core/scss/base/pages/page-misc.scss"
// import themeConfig from "../../configs/themeConfig"
const Error = () => {
  return (
    <div className="misc-wrapper">
      {/* <a className="brand-logo" href="/">
        <img src={themeConfig.app.appLogoImage} alt="logo" className="sea_logo_header" />
      </a> */}
      <div className="misc-inner p-2 p-sm-3">
        <div className="w-100 text-center">
          <h2 className="mb-1" style={{ color: '#070707' }}>Page Not Found 🕵🏻</h2>
          <p className="mb-2" style={{ color: '#070707' }}>
            Oops! 😖 The requested URL was not found.
          </p>
          <Button
            tag={Link}
            to="/dashboard"
            color="primary"
            className="btn-sm-block mb-2"
          >
            Back to home
          </Button>
        </div>
      </div>
    </div>
  )
}
export default Error
